import { BaseApi } from './base.api.js';
import { ApiError } from '../errors/api-error.js';

export class ReportBrandingApi extends BaseApi {
    constructor(client) { super(client, '/report-branding'); }

    async getCurrent() {
        try {
            return (await this.client.get(this.basePath)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async updateCurrent(data) {
        try {
            return (await this.client.put(this.basePath, data)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async createDesignerCapability(data) {
        try {
            return (await this.client.post(`${this.basePath}/designer-capability`, data)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }


    async commitChrome(data) {
        try {
            return (await this.client.post(`${this.basePath}/chrome/commit`, data)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
    async previewChrome(data) {
        try {
            const response = await this.client.post(
                `${this.basePath}/chrome/preview`,
                data,
                { responseType: 'blob' },
            );
            return {
                success: true,
                data: response.data,
                contentType: response.headers?.['content-type'] || 'application/pdf',
                contentDisposition: response.headers?.['content-disposition'] || '',
            };
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async resetChrome(data) {
        try {
            return (await this.client.post(`${this.basePath}/chrome/reset`, data)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
    async getChromeSaveReceipt(editSessionId, saveId) {
        try {
            return (await this.client.get(
                `${this.basePath}/chrome-layout/edit-sessions/${encodeURIComponent(editSessionId)}/saves/${encodeURIComponent(saveId)}`,
            )).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
    async replaceLogo(file, expectedVersion) {
        try {
            const form = new FormData();
            form.append('logo', file);
            form.append('expectedVersion', String(expectedVersion));
            return (await this.client.put(`${this.basePath}/logo`, form)).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }

    async deleteLogo(expectedVersion) {
        try {
            return (await this.client.delete(`${this.basePath}/logo`, {
                params: { expectedVersion },
            })).data;
        } catch (error) {
            throw ApiError.fromResponse(error);
        }
    }
}
